import { keyBy } from 'lodash';

import constants from './utils/constants';
import { glossaryT } from './root/i18n';

const api = window.__WS_CTX__.apiEndpoints.wsCoreHost;
const hr = window.__WS_CTX__.hrSiteAddress;

let jobs = 'https://jobs-dev.workstream.us/j';
let work = 'https://j-dev.wrkstrm.us';
let helloSignClientId = '1229905e27e23c3355cfe3c0e25c3cd3';
let skipDomainVerificationHelloSign = true;
let actionCableUrl = 'wss://api-dev.workstream.us/cable';
let googleOauthClientId = '282287906277-2qa62lpm9scas78vdn2ura39n8m784ql.apps.googleusercontent.com';
let adpConnectLink = 'https://apps.adp.com/en-US/apps/306100';
let wsSignupLink = 'https://signup-dev.workstream.us';
let sentryRelease = 'HRDefaultRelease';
// This DSN is for sentry bug tracking
const sentryDSN = 'https://e72a5e8c4d284a3cadc4d4c7e07b1d5c@o404030.ingest.sentry.io/5739186';
let indeedOauthClientId = '77ce2fbaad2d644711a3b65e9d7e6417b2890f92d0777032e73122cf8caf95eb';
let payrollAppLink = 'https://payroll.dev.workstream.us';

if (window.__WS_CTX__.wsDeployEnv === 'production') {
  jobs = 'https://jobs.workstream.us/j';
  work = 'https://j.wrkstrm.us';
  wsSignupLink = 'https://signup.workstream.us';
  actionCableUrl = 'wss://api-backend.workstream.us/cable';

  helloSignClientId = 'f83ba7bc9a42dd1a16a4d50ae7c4d20a';
  skipDomainVerificationHelloSign = false;
  googleOauthClientId = '905873288640-3eqvmikk66nq9afo5rilc5uaijjqcm1d.apps.googleusercontent.com';
  adpConnectLink = 'https://apps.adp.com/en-US/apps/292061';
  sentryRelease = process.env.SENTRY_RELEASE;
  indeedOauthClientId = '95e7eb6c2b5029d39149a090f78fc29a0255fda453db3d8a3bde26a0d4d64e1e';
  payrollAppLink = 'https://payroll.workstream.us';
}

if (window.__WS_CTX__.wsDeployEnv === 'staging') {
  jobs = 'https://jobs-staging.workstream.us/j';
  work = 'https://j-staging.wrkstrm.us';
  wsSignupLink = 'https://signup-staging.workstream.us';
  actionCableUrl = 'wss://api-staging.workstream.us/cable';
  helloSignClientId = '5a219c5403011d3eb59fda76c2c652db';
  skipDomainVerificationHelloSign = false;
  googleOauthClientId = '282287906277-3l5iefukiorvv0h76979k7k727c2ft67.apps.googleusercontent.com';
  indeedOauthClientId = '9e95a5656c0fdf85778f8aa559e6038641419959d1d36060d697e83cc04279ed';
  payrollAppLink = 'https://payroll.staging.workstream.us';
}

if (window.__WS_CTX__.wsDeployEnv === 'staging-2') {
  jobs = 'https://jobs-staging-2.workstream.us/j';
  work = 'https://j-staging-2.wrkstrm.us';
  actionCableUrl = 'wss://api-staging-2.workstream.us/cable';
  helloSignClientId = 'c71a647d5b333464a97ca6f097c87fa9';
  skipDomainVerificationHelloSign = false;
  googleOauthClientId = '282287906277-3l5iefukiorvv0h76979k7k727c2ft67.apps.googleusercontent.com';
  indeedOauthClientId = 'd06199aef85c19a040502c1df6b55d4011c8c7c6915ca2aab41c0dca0ee6f7c6';
}

if (window.__WS_CTX__.wsDeployEnv === 'staging-4') {
  jobs = 'https://jobs-staging-4.workstream.us/j';
  work = 'https://j-staging-4.wrkstrm.us';
  actionCableUrl = 'wss://api-staging-4.workstream.us/cable';
  helloSignClientId = 'f2fce69f1167948fbd7d6599098503a0';
  skipDomainVerificationHelloSign = false;
  googleOauthClientId = '282287906277-3l5iefukiorvv0h76979k7k727c2ft67.apps.googleusercontent.com';
  indeedOauthClientId = '7f799fd3845de5d31a119904fda9aa0c561de5a0f0fe7d1ac1e85bb6193b4af3';
}
if (window.__WS_CTX__.wsDeployEnv === 'staging-6') {
  jobs = 'https://jobs-stg6.staging.workstream.us/j';
  work = 'https://jobs-stg6.wrkstrm.us';
  actionCableUrl = 'wss://staging6.staging.workstream.us/cable';
  helloSignClientId = '019c386e1d24234ee8186235bfb91841';
  skipDomainVerificationHelloSign = false;
  googleOauthClientId = '282287906277-3l5iefukiorvv0h76979k7k727c2ft67.apps.googleusercontent.com';
}
if (window.__WS_CTX__.wsDeployEnv === 'staging-seed') {
  jobs = 'https://jobs-staging-seed.workstream.us/j';
  work = 'https://j-staging-seed.wrkstrm.us';
  actionCableUrl = 'wss://api-staging-seed.workstream.us/cable';
  helloSignClientId = '4ce491dc03205c76115ed7226b9e3c1b';
  skipDomainVerificationHelloSign = false;
  googleOauthClientId = '282287906277-3l5iefukiorvv0h76979k7k727c2ft67.apps.googleusercontent.com';
}

if (window.__WS_CTX__.wsDeployEnv === 'trunk') {
  jobs = 'https://jobs-trunk.workstream.us/j';
  work = 'https://j-trunk.wrkstrm.us';
  actionCableUrl = 'wss://api-trunk.workstream.us/cable';
  helloSignClientId = '3830caf892ed60156f7d18ff054fa354';
  skipDomainVerificationHelloSign = false;
  googleOauthClientId = '282287906277-3l5iefukiorvv0h76979k7k727c2ft67.apps.googleusercontent.com';
  indeedOauthClientId = 'bf6af28b0a23153c3064b3a7ca4ec30d5b02355ab8a4f4cda30064a93823f49f';
}

if (window.__WS_CTX__.wsDeployEnv === 'sandbox') {
  jobs = 'https://jobs-sandbox.workstream.us/j';
  work = 'https://j-sandbox.wrkstrm.us';
  actionCableUrl = 'wss://api-sandbox.workstream.us/cable';
  helloSignClientId = '8e48e3a39e8c7b188daeedd8ac3686e8';
  skipDomainVerificationHelloSign = true;
  googleOauthClientId = '282287906277-3l5iefukiorvv0h76979k7k727c2ft67.apps.googleusercontent.com';
}

if (window.__WS_CTX__.wsDeployEnv === 'local') {
  jobs = process.env.WS_JOBS_BASE || 'http://localhost:4000/j';
  work = process.env.WS_WORK_BASE || jobs;
  actionCableUrl = process.env.WS_CABLE_BASE || 'ws://localhost:3000/cable';
  googleOauthClientId = '282287906277-1gger361ttsi2brn8hlp6m0se5nt7o54.apps.googleusercontent.com';
}

export const previewHOST = jobs;
export const copyLinkHOST = work;
export const APIHOST = api;
export const HRHOST = hr;
export const HELLOSIGN_CLIENT_ID = helloSignClientId;
export const SKIP_DOMAIN_VERIFICATION_HELLOSIGN = skipDomainVerificationHelloSign;
export const ACTION_CABLE_URL = actionCableUrl;
export const GOOGLE_OAUTH_CLIENT_ID = googleOauthClientId;
export const ADP_CONNECTOR_LINK = adpConnectLink;
export const WS_SIGNUP_LINK = wsSignupLink;
export const DEPLOY_ENV = window.__WS_CTX__.wsDeployEnv;
export const SENTRY_RELEASE = sentryRelease;
export const SENTRY_DSN = sentryDSN;
export const ENABLE_REDUX_LOGGER = process.env.ENABLE_REDUX_LOGGER as unknown as boolean;
export const WS_DISABLE_WEBSOCKET = process.env.WS_DISABLE_WEBSOCKET as unknown as boolean;
export const INDEED_OAUTH_REDIRECT_URL = `${api}/indeed/accounts/auth`;
export const INDEED_OAUTH_CLIENT_ID = indeedOauthClientId;
export const INDEED_ATS_KEY = 'W8B0I4D8S8';
export const PAYROLL_APP_LINK = payrollAppLink;

export const automationRules = [
  {
    type: constants.AUTOMATIONS.APPLICATION_ADVANCE,
    triggerText: 'applicant submits application and passes smart screening (if applicable)',
    description: 'advance applicants on form response includes smart screen questions',
    allowMultiple: false,
  },

  {
    type: constants.AUTOMATIONS.FORM_ADVANCE,
    triggerText: 'applicant submits online form',
    description: 'advance applicants on form response',
    allowMultiple: false,
  },

  {
    type: constants.AUTOMATIONS.QUIZ_ADVANCE,
    triggerText: 'applicant submits quiz',
    description: 'advance applicants on quiz response',
    allowMultiple: false,
  },

  {
    type: constants.AUTOMATIONS.OFFER_SEND,
    triggerText: 'applicant is moved to this stage',
    description: 'send applicant offer',
    allowMultiple: false,
  },

  {
    type: constants.AUTOMATIONS.OFFER_ADVANCE,
    triggerText: 'applicant completes the signing request',
    description: 'advance applicants on offer response',
    allowMultiple: false,
  },

  {
    type: constants.AUTOMATIONS.OFFER_REMINDER,
    triggerText: 'applicant does not complete the signing request',
    description: '',
    allowMultiple: true,
  },

  {
    type: constants.AUTOMATIONS.QUIZ_REMINDER,
    triggerText: 'applicant does not respond to quiz',
    description: '',
    allowMultiple: true,
  },

  {
    type: constants.AUTOMATIONS.FORM_REMINDER,
    triggerText: 'applicant does not respond to form',
    description: '',
    allowMultiple: true,
  },

  {
    type: constants.AUTOMATIONS.MEETING_REMINDER,
    triggerText: 'an event has been confirmed',
    description: '',
    allowMultiple: true,
  },

  {
    type: constants.AUTOMATIONS.SCHEDULING_REMINDER,
    triggerText: 'applicant does not select a time',
    description: '',
    allowMultiple: true,
  },

  // BACKGROUND_CHECK_SEND: 'send background check request',
  // BACKGROUND_CHECK_REMINDER: 'background_check reminder',
  // BACKGROUND_CHECK_ADVANCE: 'background check advance',
  // Background check
  {
    type: constants.AUTOMATIONS.BACKGROUND_CHECK_SEND,
    triggerText: 'applicant is moved to this stage',
    description: 'send background check request',
    allowMultiple: false,
  },

  {
    type: constants.AUTOMATIONS.BACKGROUND_CHECK_ADVANCE,
    triggerText: 'applicant passes background check',
    description: 'move applicant to next stage',
    allowMultiple: false,
  },

  {
    type: constants.AUTOMATIONS.BACKGROUND_CHECK_REMINDER,
    triggerText: 'applicant does not respond to background check request',
    description: '',
    allowMultiple: true,
  },
  {
    type: constants.AUTOMATIONS.AUTO_REJECTION,
    triggerText: 'applicant has been in this stage',
    description: '',
    allowMultiple: false,
  },
].map((rule) => ({
  ...rule,
  triggerText: glossaryT(`hiring_process_template.automation_rule.${rule.type}`, rule.triggerText),
  description: glossaryT(`hiring_process_template.automation_rule.${rule.type}`, rule.description),
}));

export const automationRuleByType = keyBy(automationRules, 'type');

// Intercom settings
const intercomSettings = {
  appId: 'r6we9b43',
};

if (window.__WS_CTX__.wsDeployEnv === 'production') {
  intercomSettings.appId = 'lmaakz1h';
}

export { intercomSettings };

export const applicationActionNameCodeMap = {
  MOVE_TO_STAGE: 0,
  SEND_EMAIL: 2,
  SEND_SMS: 3,
  ADD_NOTE: 4,
  REJECT: 5,
  SEND_SIGNING_REQUEST: 6,
  UN_REJECT: 7,
  SHARE_APPLICANT: 8,
  MOVE_TO_POSITION: 9,
  SEND_REMINDER: 10,
  ORDER_BACKGROUND_CHECK: 11,
  CONFIRM_MEETING: 12,
  REQUEST_RESCHEDULE: 13,
  CANCEL_MEETING: 14,
  MARK_HIRED: 15,
  MARK_NOT_HIRED: 16,
  ASSIGN_TIME: 17,
  PRINT_APPLICANT: 19,
  MARK_SCHEDULE_COMPLETE: 20,
  MARK_SCHEDULE_NO_SHOW: 21,
  START_ONBOARDING: 22,
  SEND_TO_PAYLOCITY: 23,
  MARK_AS_INACTIVE: 25,
  SEND_EMAIL_INACTIVE: 26,
  SEND_SMS_INACTIVE: 27,
  REJECT_APPLICANT: 28,
  UNREJECT_APPLICANT: 29,
};

export const pdfInEmailNotificationTypes = [
  'new_applicant',
  'move_position',
  'applicant_scheduling_stage',
  'meeting',
  'hr_next_day_schedule',
  'applicant_signing_complete',
];

export const liteTierNotificationTypes = ['new_applicant', 'applicant_replies_email'];

export const YOUTUBE_API_KEY = 'AIzaSyCyRNh904QrFd54lpv7SQKvlNEcdqXu3cc';
